(function () {
  'use strict';

  // buy bar mirrors the chosen tier: total after discount, and the full price struck through when there is one
  function syncBar(tier) {
    var bar = document.querySelector('[data-buybar]');
    if (!bar) return;
    var bp = bar.querySelector('[data-buybar-price]');
    var bw = bar.querySelector('[data-buybar-was]');
    var total = tier.dataset.total || (tier.querySelector('.tier__p') || {}).textContent || '';
    if (bp && total) bp.textContent = total.trim();
    if (bw) {
      var was = tier.dataset.was || '';
      bw.textContent = was;
      bw.hidden = !was;
    }
  }

  document.addEventListener('click', function (e) {
    // mobile nav drawer
    var b = e.target.closest('[data-nav-toggle]');
    if (b) {
      var n = document.getElementById('SiteNav');
      if (n) {
        var open = n.classList.toggle('is-open');
        document.body.classList.toggle('nav-lock', open);
        var burger = document.querySelector('.burger[data-nav-toggle]');
        if (burger) burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      return;
    }

    // product gallery
    var t = e.target.closest('[data-thumb]');
    if (t) {
      var m = document.getElementById('PdpMain');
      if (m) { m.src = t.dataset.full; m.srcset = ''; }
      var all = document.querySelectorAll('[data-thumb]');
      for (var i = 0; i < all.length; i++) all[i].setAttribute('aria-current', all[i] === t ? 'true' : 'false');
      return;
    }

    // bundle tiers
    var tier = e.target.closest('[data-tier]');
    if (tier) {
      var wrap = tier.closest('[data-tiers]');
      var all = wrap.querySelectorAll('[data-tier]');
      for (var t = 0; t < all.length; t++) {
        all[t].classList.toggle('is-on', all[t] === tier);
        all[t].setAttribute('aria-pressed', all[t] === tier ? 'true' : 'false');
      }
      var qty = document.querySelector('[data-qty-input]');
      if (qty) qty.value = tier.dataset.qty;
      syncBar(tier);
      return;
    }

  });

  // close the drawer with Escape
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var n = document.getElementById('SiteNav');
    if (n && n.classList.contains('is-open')) {
      n.classList.remove('is-open');
      document.body.classList.remove('nav-lock');
    }
  });

  // back to top
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-totop]')) window.scrollTo({ top: 0, behavior: 'smooth' });
  });
  window.addEventListener('scroll', function () {
    var b = document.querySelector('[data-totop]');
    if (b) b.classList.toggle('is-on', window.scrollY > 700);
  }, { passive: true });

  // sticky mobile buy bar: shows once the real add-to-cart scrolls away
  document.addEventListener('DOMContentLoaded', function () {
    if (document.querySelector('[data-buybar]')) document.body.classList.add('has-buybar');
    // sync the buy bar with any pre-selected tier
    var on = document.querySelector('[data-tier].is-on');
    if (on) {
      var q = document.querySelector('[data-qty-input]');
      if (q) q.value = on.dataset.qty;
      syncBar(on);
    }
    var bar = document.querySelector('[data-buybar]');
    var anchor = document.querySelector('[data-buybar-anchor]');
    if (!bar || !anchor || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entries) {
      bar.classList.toggle('is-on', !entries[0].isIntersecting);
    }, { rootMargin: '0px 0px -60px 0px' }).observe(anchor);

    var proxy = bar.querySelector('[data-buybar-submit]');
    if (proxy) {
      proxy.addEventListener('click', function () {
        var form = anchor.closest('form') || document.querySelector('form[action*="/cart/add"]');
        if (form) form.requestSubmit ? form.requestSubmit() : form.submit();
      });
    }
  });

  /* ---------------------------------------------------------------
     Product finder quiz
     Weighted scoring. Nothing is decided until the last question is
     answered: each option only adds points, and the result is worked
     out from the running totals at the end.
  ----------------------------------------------------------------*/
  function Quiz(root) {
    var total   = parseInt(root.dataset.total, 10) || 0;
    if (total < 1) return;   // a section with no questions renders nothing to run
    var tie     = parseInt(root.dataset.tie, 10);
    if (isNaN(tie)) tie = 1;
    var steps   = root.querySelectorAll('.quiz__step');
    var bar     = root.querySelector('[data-quiz-bar]');
    var backBtn = root.querySelector('[data-quiz-back]');
    var againBtn= root.querySelector('[data-quiz-restart]');
    var answers = [];      // answers[i] = {c, a, el}
    var at      = 1;       // 1..total, or 'result'

    function panel(sel) {
      for (var i = 0; i < steps.length; i++) steps[i].classList.remove('is-on');
      var el = root.querySelector(sel);
      if (el) el.classList.add('is-on');
    }
    function progress(n) {
      if (bar) bar.style.width = Math.max(0, Math.min(100, Math.round((n / total) * 100))) + '%';
      var pb = root.querySelector('.quiz__bar');
      if (pb) pb.setAttribute('aria-valuenow', n);
    }
    function feet() {
      if (backBtn) backBtn.hidden = !(at === 'result' || at > 1);
      if (againBtn) againBtn.hidden = at !== 'result';
    }
    function show(n) {
      at = n;
      panel('[data-q="' + n + '"]');
      progress(n);
      feet();
      // restore the previous choice so Back is not a dead end
      var prev = answers[n - 1];
      var opts = root.querySelectorAll('[data-q="' + n + '"] [data-opt]');
      for (var i = 0; i < opts.length; i++) {
        var on = !!prev && prev.el === opts[i];
        opts[i].classList.toggle('is-on', on);
        opts[i].setAttribute('aria-pressed', on ? 'true' : 'false');
      }
      var top = root.getBoundingClientRect().top;
      if (top < 0) root.scrollIntoView({ block: 'start', behavior: 'smooth' });
    }
    function finish() {
      var c = 0, a = 0;
      for (var i = 0; i < answers.length; i++) {
        if (!answers[i]) continue;
        c += answers[i].c;
        a += answers[i].a;
      }
      var which = Math.abs(c - a) <= tie ? 'both' : (c > a ? 'classic' : 'automatic');
      at = 'result';
      panel('[data-result="' + which + '"]');
      progress(total);
      feet();
      root.scrollIntoView({ block: 'start', behavior: 'smooth' });
    }

    root.addEventListener('click', function (e) {
      var opt = e.target.closest('[data-opt]');
      if (opt && root.contains(opt)) {
        var step = opt.closest('[data-q]');
        var n = parseInt(step.dataset.q, 10);
        answers[n - 1] = {
          c: parseInt(opt.dataset.c, 10) || 0,
          a: parseInt(opt.dataset.a, 10) || 0,
          el: opt
        };
        var sib = step.querySelectorAll('[data-opt]');
        for (var i = 0; i < sib.length; i++) {
          sib[i].classList.toggle('is-on', sib[i] === opt);
          sib[i].setAttribute('aria-pressed', sib[i] === opt ? 'true' : 'false');
        }
        // let the selection register visually before moving on
        setTimeout(function () { n < total ? show(n + 1) : finish(); }, 190);
        return;
      }
      if (e.target.closest('[data-quiz-back]')) {
        if (at === 'result') show(total);
        else if (at > 1) show(at - 1);
        return;
      }
      if (e.target.closest('[data-quiz-restart]')) {
        answers = [];
        show(1);
      }
    });

    show(1);
  }

  /* ---- Video --------------------------------------------------------------
     Phones are the constraint here, so:
       - nothing downloads until the visitor is close to the video
       - a looping clip plays only while it is on screen and pauses when it
         leaves, so it does not drain battery or data in the background
       - autoplay is skipped entirely for reduced motion, data saver and slow
         connections; those visitors still get the poster and the play button
       - if autoplay is refused by the browser, the play button comes back
         instead of leaving a dead frame
  --------------------------------------------------------------------------- */
  function motionOk() {
    try {
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return false;
    } catch (e) {}
    var c = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (c) {
      if (c.saveData) return false;
      if (/2g/.test(c.effectiveType || '')) return false;
    }
    return true;
  }

  function showButton(frame) {
    var box = frame.closest('.vid');
    if (box) box.classList.remove('is-playing');
  }

  function Video() {
    var boxes = document.querySelectorAll('.vid');
    if (!boxes.length) return;
    var allowMotion = motionOk();

    // click to play
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-vid-play]');
      if (btn) {
        var box = btn.closest('.vid');
        var v = box && box.querySelector('video');
        if (!v) return;
        v.setAttribute('controls', '');
        box.classList.add('is-playing');
        var p = v.play();
        if (p && p.catch) p.catch(function () { showButton(btn); });
        return;
      }
      var emb = e.target.closest('[data-vid-embed]');
      if (emb) {
        var f = emb.closest('[data-embed]');
        var box2 = emb.closest('.vid');
        if (!f || !f.dataset.embed) return;
        var host = f.dataset.host === 'vimeo'
          ? 'https://player.vimeo.com/video/' + f.dataset.embed + '?autoplay=1&title=0&byline=0'
          : 'https://www.youtube.com/embed/' + f.dataset.embed + '?autoplay=1&rel=0&playsinline=1';
        var ifr = document.createElement('iframe');
        ifr.src = host;
        ifr.setAttribute('allow', 'autoplay; fullscreen; picture-in-picture');
        ifr.setAttribute('allowfullscreen', '');
        ifr.setAttribute('title', 'Video');
        f.innerHTML = '';
        f.appendChild(ifr);
        if (box2) box2.classList.add('is-playing');
      }
    });

    // looping clips: load and play only while on screen
    var autos = document.querySelectorAll('video[data-vid-auto]');
    if (!autos.length) return;

    if (!allowMotion) {
      // leave the poster in place and give them a real control instead
      for (var k = 0; k < autos.length; k++) {
        autos[k].setAttribute('controls', '');
        autos[k].removeAttribute('loop');
      }
      return;
    }

    if (!('IntersectionObserver' in window)) {
      for (var j = 0; j < autos.length; j++) autos[j].setAttribute('controls', '');
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting) {
          if (v.preload === 'none') { v.preload = 'auto'; v.load(); }
          var pr = v.play();
          if (pr && pr.catch) pr.catch(function () {
            // autoplay refused, hand it back to the visitor
            v.setAttribute('controls', '');
            showButton(v);
          });
        } else if (!v.paused) {
          v.pause();
        }
      });
    }, { rootMargin: '200px 0px', threshold: 0.25 });

    for (var i2 = 0; i2 < autos.length; i2++) io.observe(autos[i2]);
  }

  document.addEventListener('DOMContentLoaded', function () {
    var qs = document.querySelectorAll('[data-quiz]');
    for (var i = 0; i < qs.length; i++) Quiz(qs[i]);
    Video();
  });

})();

/* ---------------------------------------------------------------
   Mixing scents (appended module).
   Every Classic scent is its own product, and the 2-set and 3-set
   discounts apply to any mix of them. So the tiers count the sets
   already in the cart (any scent) plus what is chosen here, and the
   small Add buttons put another scent in the cart without leaving
   the page. base = Classic sets already in the cart.
   Tier clicks are handled here in the capture phase so the basic
   handler above never sees them.
----------------------------------------------------------------*/
(function () {
  'use strict';

  function syncBar(tier) {
    var bar = document.querySelector('[data-buybar]');
    if (!bar) return;
    var bp = bar.querySelector('[data-buybar-price]');
    var bw = bar.querySelector('[data-buybar-was]');
    var total = tier.dataset.total || '';
    if (bp && total) bp.textContent = total.trim();
    if (bw) { var was = tier.dataset.was || ''; bw.textContent = was; bw.hidden = !was; }
  }

  var mix = { base: 0, lines: [] };

  // "$69.30" + 2475 -> "$24.75": keep whatever symbol and spacing the store uses
  function money(cents, sample) {
    var num = (cents / 100).toFixed(2);
    if (!sample) return '$' + num;
    return sample.replace(/[\d][\d.,]*/, num);
  }

  // the sticky bar shows what the button will add, not the whole order
  function barFor(tier, mine) {
    var each = parseInt(tier.dataset.eachCents, 10), unit = parseInt(tier.dataset.unitCents, 10);
    if (!mix.base || isNaN(each) || isNaN(unit)) return tier;
    return { dataset: { total: money(each * mine, tier.dataset.total), was: tier.dataset.was ? money(unit * mine, tier.dataset.total) : '' } };
  }

  function scentMap() {
    var m = {};
    var els = document.querySelectorAll('[data-scent]');
    for (var i = 0; i < els.length; i++) m[els[i].dataset.variant] = els[i];
    return m;
  }

  function selectTier(tier) {
    var wrap = tier.closest('[data-tiers]');
    var all = wrap.querySelectorAll('[data-tier]');
    for (var t = 0; t < all.length; t++) {
      all[t].classList.toggle('is-on', all[t] === tier);
      all[t].setAttribute('aria-pressed', all[t] === tier ? 'true' : 'false');
    }
    var n = parseInt(tier.dataset.qty, 10) || 1;
    var mine = Math.max(1, n - mix.base);
    var qty = document.querySelector('[data-qty-input]');
    if (qty) qty.value = mine;
    syncBar(barFor(tier, mine));
    mixLine(wrap, tier, mine);
  }

  function unitWord(wrap, n) {
    return n === 1 ? (wrap.dataset.unitOne || 'set') : (wrap.dataset.unitMany || 'sets');
  }

  function mixLine(wrap, tier, mine) {
    var el = wrap.querySelector('[data-tiers-mix]');
    if (!el) return;
    if (!mix.base) { el.hidden = true; el.textContent = ''; return; }
    var parts = [];
    for (var i = 0; i < mix.lines.length; i++) parts.push(mix.lines[i].qty + ' \u00d7 ' + mix.lines[i].name);
    var txt = 'In your cart: ' + parts.join(', ') + '.';
    if (tier) {
      var n = parseInt(tier.dataset.qty, 10) || 1;
      txt += ' Add ' + mine + ' \u00d7 ' + (wrap.dataset.this || 'this scent') + ' and you have ' + n + ' ' + unitWord(wrap, n) + ' for ' + (tier.dataset.total || '') + '.';
    } else {
      txt += ' Every set you add now gets the best discount.';
    }
    el.textContent = txt;
    el.hidden = false;
  }

  function applyMix() {
    var wrap = document.querySelector('[data-tiers]');
    if (!wrap) return;
    var heading = wrap.querySelector('[data-tiers-heading]');
    if (heading) {
      if (!heading.dataset.orig) heading.dataset.orig = heading.textContent;
      heading.textContent = mix.base > 0 && heading.dataset.alt ? heading.dataset.alt : heading.dataset.orig;
    }
    var tiers = wrap.querySelectorAll('[data-tier]');
    var pick = null, top = null;
    for (var i = 0; i < tiers.length; i++) {
      var n = parseInt(tiers[i].dataset.qty, 10) || 0;
      var off = n <= mix.base;
      tiers[i].disabled = off;
      tiers[i].classList.toggle('is-off', off);
      if (!off && !pick) pick = tiers[i];
      top = tiers[i];
    }
    // per-scent "in cart" labels
    var els = document.querySelectorAll('[data-scent]');
    for (var j = 0; j < els.length; j++) {
      var lab = els[j].querySelector('[data-scent-in]');
      if (!lab) continue;
      var q = 0;
      for (var k = 0; k < mix.lines.length; k++) if (mix.lines[k].variant === els[j].dataset.variant) q = mix.lines[k].qty;
      lab.textContent = q ? q + ' in cart' : '';
      lab.hidden = !q;
    }
    if (mix.base > 0) {
      if (pick) selectTier(pick);
      else {
        // already at or past the top tier: everything added now gets the best price
        for (var t = 0; t < tiers.length; t++) { tiers[t].classList.remove('is-on'); tiers[t].setAttribute('aria-pressed', 'false'); }
        var qty = document.querySelector('[data-qty-input]');
        if (qty) qty.value = 1;
        if (top) syncBar({ dataset: { total: top.dataset.each || top.dataset.total, was: top.dataset.unit || '' } });
        mixLine(wrap, null, 1);
      }
    } else {
      var on = wrap.querySelector('[data-tier].is-on') || tiers[0];
      if (on) selectTier(on);
    }
  }

  function readCart(cart) {
    var map = scentMap();
    mix.base = 0; mix.lines = [];
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      var el = map[String(items[i].variant_id)];
      if (!el) continue;
      mix.base += items[i].quantity;
      mix.lines.push({ variant: el.dataset.variant, name: el.dataset.name, qty: items[i].quantity });
    }
    var n = (cart && typeof cart.item_count === 'number') ? cart.item_count : 0;
    var count = document.querySelector('.hdr .cart-count');
    if (cart && typeof cart.item_count === 'number') {
      if (count) count.textContent = cart.item_count;
      else if (cart.item_count > 0) {
        var link = document.querySelector('.hdr a[href$="/cart"]');
        if (link) { var c = document.createElement('span'); c.className = 'cart-count'; c.textContent = cart.item_count; link.appendChild(c); }
      }
    }
    // Shopify's express button (Apple Pay, Google Pay) checks out this product alone and
    // ignores the cart, so it steps aside once anything is in the cart; our own Buy now is always there
    var pay = document.querySelector('[data-paybtn]');
    if (pay) pay.hidden = n > 0;
    // refill cards: show how many of each are already in the cart
    var adds = document.querySelectorAll('[data-addon]');
    for (var a = 0; a < adds.length; a++) {
      var al = adds[a].querySelector('[data-addon-in]');
      if (!al) continue;
      var aq = 0;
      for (var b = 0; b < items.length; b++) if (String(items[b].variant_id) === adds[a].dataset.variant) aq += items[b].quantity;
      al.textContent = aq ? aq + ' in cart' : '';
      al.hidden = !aq;
    }
    // the second-set line only makes sense while nothing is in the cart yet
    var hint = document.querySelector('[data-tiers-hint]');
    if (hint) hint.hidden = mix.base > 0;
    applyMix();
  }

  // Checkout entry point used everywhere. skip_shop_pay keeps Shopify from bouncing a recognised
  // email into the Shop Pay code screen; the Shop Pay button itself stays available at checkout.
  var CHECKOUT_URL = '/checkout?skip_shop_pay=true';

  // Buy now: add this product with the chosen quantity, then straight to checkout with the whole cart.
  // Used by the in-page Buy now button and by the sticky bar.
  function buyNow(form, btn) {
    if (!form) return;
    if (!window.fetch) { form.requestSubmit ? form.requestSubmit() : form.submit(); return; }
    var label = btn ? (btn.dataset.label || btn.dataset.buybarLabel || btn.textContent) : '';
    if (btn) { btn.disabled = true; btn.textContent = '…'; }
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () { window.location.href = CHECKOUT_URL; })
      .catch(function () {
        // fall back to the normal add so the customer is never stuck
        if (btn) { btn.disabled = false; btn.textContent = label; }
        form.requestSubmit ? form.requestSubmit() : form.submit();
      });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-buy-now]');
    if (!btn) return;
    e.preventDefault();
    buyNow(btn.closest('form'), btn);
  });

  // the sticky bar goes to checkout too; captured here so the basic handler never submits the form
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-buybar-submit]');
    if (!btn || !btn.dataset.buybarLabel) return;
    e.stopPropagation();
    e.preventDefault();
    var anchor = document.querySelector('[data-buybar-anchor]');
    buyNow(anchor ? anchor.closest('form') : document.querySelector('form[action*="/cart/add"]'), btn);
  }, true);

  function fetchCart() {
    if (!document.querySelector('[data-scents], [data-addons]') || !window.fetch) return;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(readCart)
      .catch(function () {});
  }

  document.addEventListener('click', function (e) {
    var tier = e.target.closest('[data-tier]');
    if (!tier) return;
    e.stopPropagation();
    e.preventDefault();
    if (tier.disabled) return;
    selectTier(tier);
  }, true);

  // gallery: thumbnails scroll the strip, swiping the strip highlights the thumbnail
  function galleryGo(i) {
    var track = document.querySelector('[data-track]');
    if (!track) return;
    loadSlides();
    track.scrollTo({ left: i * track.clientWidth, behavior: 'smooth' });
    markThumb(i);
  }
  function markThumb(i) {
    var thumbs = document.querySelectorAll('[data-thumb]');
    for (var t = 0; t < thumbs.length; t++) {
      var on = t === i;
      thumbs[t].setAttribute('aria-current', on ? 'true' : 'false');
      if (on && thumbs[t].scrollIntoView) {
        var row = thumbs[t].parentNode, r = thumbs[t].getBoundingClientRect(), rr = row.getBoundingClientRect();
        if (r.left < rr.left || r.right > rr.right) row.scrollTo({ left: thumbs[t].offsetLeft - 12, behavior: 'smooth' });
      }
    }
  }
  document.addEventListener('click', function (e) {
    var th = e.target.closest('[data-thumb]');
    if (!th || !document.querySelector('[data-track]')) return;
    e.stopPropagation();
    e.preventDefault();
    galleryGo(parseInt(th.dataset.index, 10) || 0);
  }, true);

  // the other gallery photos load once the page is idle, or the moment the visitor swipes or taps a thumbnail
  var slidesLoaded = false;
  function loadSlides() {
    if (slidesLoaded) return;
    slidesLoaded = true;
    var imgs = document.querySelectorAll('[data-slide] img[data-src]');
    for (var i = 0; i < imgs.length; i++) {
      if (imgs[i].dataset.srcset) imgs[i].srcset = imgs[i].dataset.srcset;
      imgs[i].src = imgs[i].dataset.src;
      imgs[i].removeAttribute('data-src'); imgs[i].removeAttribute('data-srcset');
    }
  }
  window.addEventListener('load', function () {
    var idle = window.requestIdleCallback || function (fn) { setTimeout(fn, 1200); };
    idle(loadSlides, { timeout: 3000 });
  });
  document.addEventListener('touchstart', function (e) { if (e.target.closest('[data-track], [data-thumbs]')) loadSlides(); }, { passive: true, capture: true });
  document.addEventListener('pointerdown', function (e) { if (e.target.closest('[data-track], [data-thumbs]')) loadSlides(); }, { passive: true, capture: true });

  document.addEventListener('DOMContentLoaded', function () {
    var on = document.querySelector('[data-tier].is-on');
    if (on) selectTier(on);
    fetchCart();
    // keep the sticky bar away while the express button or Buy it now is still on screen
    var bar = document.querySelector('[data-buybar]');
    var below = document.querySelectorAll('[data-paybtn], [data-buy-now]');
    if (bar && below.length && 'IntersectionObserver' in window) {
      var seen = [];
      var hold = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          var idx = Array.prototype.indexOf.call(below, entries[i].target);
          seen[idx] = entries[i].isIntersecting && !entries[i].target.hidden;
        }
        var any = false;
        for (var s = 0; s < seen.length; s++) if (seen[s]) any = true;
        bar.classList.toggle('is-hold', any);
      }, { rootMargin: '0px 0px -60px 0px' });
      for (var b = 0; b < below.length; b++) hold.observe(below[b]);
    }
    var track = document.querySelector('[data-track]');
    if (track) {
      var tick = null;
      track.addEventListener('scroll', function () {
        if (tick) return;
        tick = setTimeout(function () { tick = null; markThumb(Math.round(track.scrollLeft / Math.max(1, track.clientWidth))); }, 80);
      }, { passive: true });
    }
  });

  // add another scent without leaving the page
  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-scent-form]');
    if (!form || !window.fetch) return;
    e.preventDefault();
    var btn = form.querySelector('[data-scent-add]');
    if (btn) { btn.disabled = true; btn.textContent = '\u2026'; }
    var fd = new FormData(form);
    fetch('/cart/add.js', { method: 'POST', body: fd, headers: { 'Accept': 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () {
        if (btn) { btn.textContent = btn.dataset.done || 'Added'; btn.classList.add('is-done'); }
        return fetch('/cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); }).then(function (cart) {
          readCart(cart);
          document.dispatchEvent(new CustomEvent('c33:cart', { detail: cart }));
        });
      })
      .catch(function () {
        // fall back to the normal request so the customer is never stuck
        form.removeAttribute('data-scent-form');
        form.submit();
      })
      .then(function () {
        if (btn) setTimeout(function () { btn.disabled = false; btn.textContent = btn.dataset.label || 'Add'; btn.classList.remove('is-done'); }, 1800);
      });
  });
})();

/* ---------------------------------------------------------------------------
   Cart page (appended module).
   Plus and minus buttons change a line through /cart/change.js and the page
   redraws itself from Shopify's section rendering, so there is no Update
   button and no full reload. The "add another scent" and "add refills" rows
   reuse the product page Add forms; once something is added the list is
   refreshed the same way. Without JavaScript the plain form still works.
   --------------------------------------------------------------------------- */
(function () {
  'use strict';
  var root = document.querySelector('[data-cart]');
  if (!root || !window.fetch) return;
  var busy = false;

  function swap(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-cart]');
    var cur = document.querySelector('[data-cart]');
    if (fresh && cur) { cur.replaceWith(fresh); root = fresh; }
  }

  function refresh() {
    var id = root.dataset.section;
    // no JSON accept header here: on /cart that would return the cart itself instead of the rendered section
    return fetch(window.location.pathname + '?sections=' + encodeURIComponent(id))
      .then(function (r) { return r.json(); })
      .then(function (j) { if (j && j[id]) swap(j[id]); });
  }

  function change(line, qty) {
    if (busy) return;
    busy = true;
    root.setAttribute('aria-busy', 'true');
    var id = root.dataset.section;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty, sections: id })
    })
      .then(function (r) { if (!r.ok) throw new Error('change failed'); return r.json(); })
      .then(function (cart) {
        if (cart.sections && cart.sections[id]) swap(cart.sections[id]); else return refresh();
        var count = document.querySelector('.hdr .cart-count');
        if (count) { count.textContent = cart.item_count; count.hidden = !cart.item_count; }
      })
      .catch(function () { window.location.reload(); })
      .then(function () { busy = false; var r2 = document.querySelector('[data-cart]'); if (r2) r2.removeAttribute('aria-busy'); });
  }

  document.addEventListener('click', function (e) {
    var minus = e.target.closest('[data-qty-minus]');
    var plus = e.target.closest('[data-qty-plus]');
    var rm = e.target.closest('[data-cart-remove]');
    var btn = minus || plus || rm;
    if (!btn || !btn.closest('[data-cart]')) return;
    e.preventDefault();
    var line = parseInt(btn.dataset.line, 10);
    var input = btn.closest('[data-cart]').querySelector('[data-qty-line="' + line + '"]');
    var now = input ? parseInt(input.value, 10) || 0 : 0;
    if (rm) change(line, 0);
    else if (minus) change(line, Math.max(0, now - 1));
    else change(line, now + 1);
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-qty-line]');
    if (!input || !input.closest('[data-cart]')) return;
    change(parseInt(input.dataset.qtyLine, 10), Math.max(0, parseInt(input.value, 10) || 0));
  });

  // a scent or refill added from the rows under the list
  document.addEventListener('c33:cart', function () { refresh(); });

  // Checkout button: same entry point as Buy now on the product page (skip_shop_pay keeps a recognised
  // email from being bounced into the Shop Pay code screen). Waits for a quantity change still in flight.
  document.addEventListener('click', function (e) {
    var go = e.target.closest('[data-cart] [name="checkout"]');
    if (!go) return;
    e.preventDefault();
    var tries = 0;
    (function leave() {
      if (busy && tries++ < 30) { setTimeout(leave, 100); return; }
      window.location.href = '/checkout?skip_shop_pay=true';
    })();
  });
})();
